import { useCallback } from 'react';

import { useHandleUpdateProfileError } from '@ocx/feat-edit-profile';
import { useCustomerUpdateMutation } from '@ocx/graphql';
import { logInDev } from '@ocx/utils';

type UseCompleteEmailActionSheetControllerParams = {
  onCompleted?(): void;
};

export const useCompleteEmailActionSheetController = (params: UseCompleteEmailActionSheetControllerParams = {}) => {
  const handleError = useHandleUpdateProfileError();
  const { onCompleted } = params;
  const [updateCustomerMutation] = useCustomerUpdateMutation({
    onCompleted,
    onError: handleError,
    refetchQueries: ['currentCustomer'],
  });

  const handleUpdateEmail = useCallback(
    async (values: { email: string }) => {
      try {
        await updateCustomerMutation({ variables: { customer: { membership: { email: values.email } } } });
      } catch (e: unknown) {
        logInDev(e);
      }
    },
    [updateCustomerMutation],
  );

  return {
    handleUpdateEmail,
  };
};
